import { Column } from "../../../components/TablePaginated/TablePaginated";

export enum TabsHeaderLabel {
  PENDENTES_COMERCIAL = "Pendentes comercial",
  APROVADOS = "Aprovados",
  REPROVADOS = "Reprovados",
}

export const PENDING_HEADERS: Column[] = [
  { id: "refId", label: "ID", align: "right" },
  { id: "externalId", label: "BP", align: "right" },
  { id: "client", label: "Cliente", align: "left" },
  { id: "branch", label: "Filial", align: "left" },
  { id: "product", label: "Produto", align: "left" },
  { id: "modality", label: "Modalidade", align: "left" },
  { id: "volumeRequested", label: "Volume solicitado", align: "right" },
  { id: "scheduleDate", label: "Data prevista", align: "left" },
  { id: "scheduleTime", label: "Hora prevista", align: "left" },
  { id: "customerRequester", label: "Usuário", align: "left" },
  { id: "status", label: "Status", align: "center" },
  { id: "action", label: "", align: "left" },
];

export const APROVED_HEADERS: Column[] = [
  { id: "refId", label: "ID", align: "right" },
  { id: "externalId", label: "BP", align: "right" },
  { id: "client", label: "Cliente", align: "left" },
  { id: "branch", label: "Filial", align: "left" },
  { id: "product", label: "Produto", align: "left" },
  { id: "volumeProvided", label: "Volume aprovado", align: "right" },
  { id: "sapCorrectedVolume", label: "Volume OV", align: "right" },
  { id: "scheduleDate", label: "Data prevista", align: "left" },
  { id: "scheduleTime", label: "Hora prevista", align: "left" },
  { id: "ov", label: "OV SAP", align: "right" },
  { id: "customerRequester", label: "Usuário", align: "left" },
  { id: "status", label: "Status", align: "left" },
  { id: "action", label: "", align: "left" },
];

export const REPROVED_HEADERS: Column[] = [
  { id: "refId", label: "ID", align: "right" },
  { id: "externalId", label: "BP", align: "right" },
  { id: "client", label: "Cliente", align: "left" },
  { id: "branch", label: "Filial", align: "left" },
  { id: "product", label: "Produto", align: "left" },
  { id: "volumeRequested", label: "Volume solicitado", align: "right" },
  { id: "scheduleDate", label: "Data prevista", align: "left" },
  { id: "scheduleTime", label: "Hora prevista", align: "left" },
  { id: "customerRequester", label: "Usuário", align: "left" },
  { id: "status", label: "Status", align: "left" },
  { id: "action", label: "", align: "left" },
];

export const HEADERS: Column[] = [
  { id: "client", label: "Cliente", align: "left" },
  { id: "branch", label: "Filial", align: "left" },
  { id: "CNPJ", label: "CNPJ", align: "left" },
  { id: "product", label: "Produto", align: "left" },
  { id: "modality", label: "Modalidade", align: "left" },
  { id: "monthlyQuota", label: "Cota Mês", align: "left" },
  { id: "updatedQuota", label: "Cota atualizada", align: "left" },
  { id: "additional", label: "Adicional", align: "left" },
  { id: "cut", label: "Corte", align: "left" },
  { id: "antecipation", label: "Antecipação", align: "left" },
  { id: "balance", label: "Saldo", align: "left" },
  { id: "invoicedVolume", label: "Volume faturado", align: "left" },
];

export const BALANCE_HEADERS: Column[] = [
  { id: "CNPJ", label: "CNPJ", align: "left" },
  { id: "invoice", label: "Nº da Fatura", align: "left" },
  { id: "salesOrder", label: "Ordem de Venda", align: "left" },
  { id: "nf", label: "NF", align: "left" },
  { id: "series", label: "Série", align: "left" },
  { id: "nfDate", label: "Data NF", align: "left" },
  { id: "orderDate", label: "Data do Pedido", align: "left" },
  { id: "type", label: "Tipo", align: "center" },
  { id: "value", label: "Quantidade", align: "right" },
  {
    id: "remainingQuotaBalance",
    label: "Saldo",
    align: "right",
  },
];

export const BALANCE_SUMMARY_HEADERS: Column[] = [
  { id: "customerCompany", label: "Cliente", align: "left" },
  { id: "CNPJ", label: "CNPJ", align: "left" },
  { id: "product", label: "Produto", align: "left" },
  { id: "mod", label: "Modalidade", align: "left" },
  { id: "quota", label: "Cota Mês", align: "right" },
  { id: "finalQuota", label: "Cota Atualizada", align: "right" },
  { id: "added", label: "Adicionado", align: "right" },
  { id: "cut", label: "Cortado", align: "right" },
  { id: "stated", label: "Retirado", align: "right" },
  { id: "balance", label: "Saldo Final", align: "right" },
];
